import { PlanYear } from './PlanYear.Type';
import { ComponentProps } from 'lib/component-props';
import { County } from './Counties.Type';

export type PlanOptionsListingProps = ComponentProps & {
  fields: {
    compareError: string;
    compareSelect: string;
    comparepageurl: string;
    counties: County[];
    crmPrefix: string;
    description: string;
    detailpageurl: string;
    enableFilters: boolean;
    filters?: ListingFilter[];
    maxCompare: number;
    planType: {
      id: string;
      planName: string;
    };
    planYears: PlanYear[];
    plans: Plan[];
    plansOrder: string[];
    sortingOptions?: SortingOption[];
    searchpageurl: string;
    title: string;
    useCavulus: boolean;
  };
};

export type BaseItem = {
  id: string;
  displayName: string;
};

export type SortingOption = BaseItem & {
  title: string;
  fieldName: string;
  isAscending: boolean;
};

export type ListingFilterOption = BaseItem & {
  minimum?: number;
  maximum?: number;
  selected?: boolean;
  count?: number;
};

export type ListingFilter = BaseItem & {
  setDefault: string;
  options: ListingFilterOption[];
  tooltipLabel: string;
  tooltip: string;
  selectMultiple: boolean;
};

export type PlanListingFilterTagsProps = {
  selectedFilterOptions: ListingFilterOption[];
  removeOptionFromFilter: (optionId: string) => void;
};

export type PlanListingFilterProps = {
  plans: Plan[];
  filters: ListingFilter[];
  displayType: DisplayType;
  onFilterOptionSelectionChange?: (filters: ListingFilter[]) => void;

  sortingOptions?: SortingOption[];
  updatePlansSortOrder?: (sortingOption: SortingOption) => void;
  defaultSelection?: string;
};

export type PlanListingFilterOptionsListProps = {
  filter: ListingFilter;
  addDivider: boolean;
  isMobile: boolean;
  onFilterOptionChange: (option: ListingFilterOption) => void;
};

export type Plan = {
  contract: string;
  counties: PlanCounty[];
  featuredPlanEntries: FeaturedPlanEntries[];
  filters: SetFilters[];
  sortValues: SortingValues[];
  groupId: string;
  id: string;
  mcproductid: string;
  pbp: string;
  planDescription: string;
  planName: string;
  year: number;
  matchFilters: boolean;
  annualDeductibleNetworkScope: string;
  outOfPocketScope: string;
};

export type SortingValues = {
  name: string;
  value: number;
};

export type SetFilters = {
  id: string;
  name: string;
  selection: string;
  selectedNames: string;
  entry: number;
};

export type PlanCounty = {
  id: string;
  name: string;
  state: string;
};

export type FeaturedPlanEntries = {
  value: string;
  groupEntry: EntryGroup;
};

export type EntryGroup = {
  label: string;
  icon: string;
  alt: string;
};

export type DisplayType = 'desktop' | 'mobile';

export type PlanListingSortingProps = {
  displayType?: DisplayType;
  sortingOptions?: SortingOption[];
  updatePlansSortOrder: (sortingOption: SortingOption) => void;
  defaultSelection: string | undefined;
};

export type QueryStrings = {
  state: string;
  county: string;
  year: number;
  zipcode: number;
  existingMember: boolean | null;
  filters: string[];
  sortBy: string;
};

export enum LoadingState {
  start = 'Starting',
  layout = 'Layout Check',
  query = 'Load Querystring',
  verify = 'Verify Information Loaded',
  firstPass = 'First Pass',
  secondPass = 'Second Pass',
  end = 'Finished',
}
